export default __webpack_public_path__ + "static/media/footer-img.083aa316.png";